import axios from "../axios";
// 获取学科列表
export const getSubList = (data) => {
  return axios({
    url: "/console/school_subject/enable_list",
    method: "GET",
    data: data,
  });
};

// 获取学科列表 公司端
export const adminGetSubList = (data) => {
  return axios({
    url: "/console/subject/page",
    method: "GET",
    data: data,
  });
};

// 删除学科
export const delSub = (data) => {
  return axios({
    url: "/console/school_subject/remove",
    method: "POST",
    data,
  });
};

// 获取公司端 所有学科列表
export const getAllSubList = (data) => {
  return axios({
    url: "/console/subject/list",
    method: "GET",
    data: data,
  });
};

// 添加学科
export const addSub = (data) => {
  return axios({
    url: "/console/school_subject/save",
    method: "POST",
    data,
  });
};

// 添加学科 公司端
export const adminAddSub = (data) => {
  return axios({
    url: "/console/subject/save",
    method: "POST",
    data,
  });
};

// 编辑科目 公司端
export const editSub = (data) => {
  return axios({
    url: "/console/subject/update",
    method: "POST",
    data,
  });
};



// WEBPACK FOOTER //
// ./src/http/moudules/subjectManagement.js